import { Divider, Icon, IconButtonButton } from "@evergis/ui";
import styled from "styled-components";
import { FiltersCollapsed } from "../../../../modules/Catalog/components/FiltersCollapsed/FiltersCollapsed";
import { LinkButton } from "../../DialogComponents/styled";
import { fadeInKeyframes } from "../styled";

export const StyledFilters = styled(FiltersCollapsed)`
  flex-direction: column;
  width: 17.5rem;
  box-sizing: border-box;
  height: auto !important;
  max-height: 20rem !important;
  padding: 0 0 1rem;
  align-items: start;
  position: relative;
`;

export const ResourceFiltersContainer = styled.div`
  display: flex;
  gap: 0 0.5rem;
  font-size: 14px;
  align-items: center;
`;

export const IconText = styled.span`
  font-weight: 600;
`;

export const FiltersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 1;
  padding: 1rem;
  box-sizing: border-box;
  background-color: ${({ theme: { palette } }) => palette.background};
  box-shadow: ${({ theme: { palette } }) => palette.elementDeep} 0 1px 0 0;
`;

export const FiltersHeaderShadow = styled.div`
  position: absolute;
  z-index: 2;
  background-color: ${({ theme: { palette } }) => palette.background};
  width: 100%;
  height: 1px;
  top: 51px;
`;

export const FiltersHeaderTitle = styled.div``;

export const FiltersContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem 0;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
`;

export const FilterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem 0;
  width: 100%;
  position: relative;
`;

export const SelectFilesFiltersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem 0;
  padding: 0 3.5rem 1rem 3rem;
  box-sizing: border-box;
`;

export const FiltersTagsContainer = styled.div<{ haveFilters?: boolean }>`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 0.5rem 0.25rem;
  padding-top: ${({ haveFilters }) => (haveFilters ? "1rem" : 0)};
`;

export const FilterClearButton = styled(LinkButton)`
  position: absolute;
  right: 0.5rem;
  top: 4px;
  font-size: 12px;
`;

export const ResourceFiltersContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.palette.background};
  width: 18rem;
  height: calc(100vh - 7rem);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 1.5rem;
  gap: 1.5rem 0;
  border-radius: 0.5rem;
  animation: ${fadeInKeyframes} 0.3s ease-in-out;
`;

export const ResourceCategoryFilterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem 0;
`;

export const CategoryFilterIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

export const CategoryFilterTitle = styled.div`
  margin-left: 0.25rem;
`;

export const ResourceCategoryFilterItem = styled.div<{ disabled?: boolean; selected?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  color: ${({ theme, disabled, selected }) =>
    selected ? "white" : disabled ? theme.palette.textDisabled : theme.palette.textSecondary};
  font-weight: 500;
  font-size: 14px;
  background: ${({ theme, selected, disabled }) => (selected && !disabled ? "#1f222a" : theme.palette.background)};
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};

  ${CategoryFilterIcon}:after {
    color: ${({ theme, disabled, selected }) =>
      selected ? "white" : disabled ? theme.palette.textDisabled : theme.palette.textSecondary};
  }

  &:hover {
    background: ${({ theme, selected, disabled }) => (selected && !disabled ? "#1f222a" : theme.palette.background)};
    color: ${({ theme, disabled, selected }) =>
      selected ? "white" : disabled ? theme.palette.textDisabled : theme.palette.textPrimary};
    font-weight: 500;

    ${CategoryFilterIcon}:after {
      color: ${({ theme, disabled, selected }) =>
        selected ? "white" : disabled ? theme.palette.textDisabled : theme.palette.textPrimary};
    }
  }
`;

export const FilterSelectorTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.25rem;
  padding-left: 0.5rem;
  box-sizing: border-box;
`;

export const FilterSelectorTitle = styled.div`
  color: ${({ theme }) => theme.palette.textSecondary};
  font-size: 12px;
  margin-top: 0.25rem;
`;

export const FilterSelectorChip = styled.div<{ selected?: boolean; disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 0.5rem;
  border-radius: 0.25rem;
  height: 1.5rem;
  gap: 0 0.25rem;
  box-sizing: border-box;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
  background: ${({ theme, selected }) => (selected ? "rgba(0, 170, 255, 0.06)" : theme.palette.element)};
  color: ${({ theme, selected, disabled }) =>
    disabled ? theme.palette.textDisabled : selected ? theme.palette.primary : theme.palette.icon};
  font-size: 12px;

  ${Icon} {
    width: 14px;
    height: 14px;
    font-size: 14px;

    &:after {
      color: ${({ theme, selected, disabled }) =>
        disabled ? theme.palette.textDisabled : selected ? theme.palette.primary : theme.palette.icon};
      font-size: 14px;
    }
  }

  &:hover {
    background: ${({ theme, selected }) => (selected ? "rgba(0, 170, 255, 0.06)" : theme.palette.elementDeep)};
  }

  ${IconButtonButton} {
    width: 14px;
    height: 14px;
  }
`;

export const FiltersDivider = styled(Divider)`
  width: 100%;
`;
